module.exports = "/assets/landing-rc/cooperation/img.jpg?sEda96K";